<div class="p-datatable p-component p-datatable-scrollable">
    <div class="p-datatable-wrapper">
        <table role="table" class="p-datatable-table p-datatable-scrollable-table" style="min-width: 50rem;">
            <thead class="p-datatable-thead">
                <tr>
                    <th class="p-element p-sortable-column" style="width: 150px;"> Thời gian
                    </th>
                    <th class="p-element p-sortable-column" style="width: 150px;"> Người tác động
                    </th>
                    <th class="p-element p-sortable-column" style="width: 150px;"> Hành động
                    </th>
                    <th class="p-element p-sortable-column" style="width: 300px;"> Nội dung</th>
                </tr>
            </thead>
            <tbody class="p-element p-datatable-tbody" *ngFor="let item of groupDetailByStep; index as i;">

                <tr >
                    <td [attr.colspan]="4" class="">
                        <b>{{item.workFlowStepByItemTitle}}</b>
                    </td>
                </tr>

                <tr   *ngFor="let itemDetail of item.listDetail; index as j;">
                    <td  style="width: 150px;" class="">
                        {{itemDetail.workFlowStepByItemDetail.creationTime | luxonFormat:'F' }}
                    </td>
                    <td  style="width: 150px;" class="">
                        {{itemDetail.userName}}
                    </td>
                    <td style="width: 150px;" class="">
                    
                        {{l( workFlowStepByItemDetailAction[itemDetail.workFlowStepByItemDetail.workFlowStepByItemDetailAction])}}
                    </td>
                    <td style="width: 300px;" class="">
                    
                        {{itemDetail.workFlowStepByItemDetail.description}}
                    </td>
                    

                </tr>
            </tbody>
        </table>
    </div>
</div>
					